<div class="add-container">
    <h1 class="add-title">Adaugă modul locații servicii active</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>User</mat-label>
                    <mat-select formControlName="id_user">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let user of users" [value]="user.id">
                            {{ user.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_user'].valid && form.controls['id_user'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Email-uri raport</mat-label>
                    <input type="text" matInput formControlName="email_to_reports" />
                    <mat-error
                        *ngIf="!form.controls['email_to_reports'].valid && form.controls['email_to_reports'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>